/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
// Generated by build-products.mjs – DO NOT EDIT BY HAND.

import posthog from "posthog-js";
import type { FileSystemImport } from "~/queries/schema/schema-general";
import type { ModelsSceneTab } from "./scenes/models/modelsSceneLogic";
import type { Params } from "scenes/sceneTypes";
import type { ProductSetupProbe } from "lib/components/ProductEmptyState/setupProbes";
import type {
  SchemaConfigurationSection,
  SchemaSceneTab,
} from "../../products/data_warehouse/frontend/scenes/SchemaScene/SchemaScene";
import type { SourceSceneTab } from "../../products/data_warehouse/frontend/scenes/SourceScene/SourceScene";
import type { WorkflowsSceneTab } from "../../products/workflows/frontend/WorkflowsScene";
import { AI_OBSERVABILITY_CLUSTER_URL_PATTERN } from "../../products/ai_observability/frontend/clusters/constants";
import {
  ActionType,
  DashboardType,
  FileSystemIconColor,
  InsightSceneSource,
  InsightShortId,
  InsightType,
  RecordingUniversalFilters,
  ReplayTabs,
  UniversalFiltersGroup,
} from "./types";
import { ActivityScope } from "~/types";
import { AlertType } from "products/alerts/frontend/types";
import {
  DashboardFilter,
  DateRange,
  ExperimentMetric,
  FileSystemIconType,
  HogQLFilters,
  HogQLQuery,
  HogQLVariable,
  Node,
  NodeKind,
  ProductItemCategory,
  ProductKey,
  TileFilters,
} from "~/queries/schema/schema-general";
import { FEATURE_FLAGS, INSIGHT_VISUAL_ORDER } from "lib/constants";
import { SurveysTabs } from "scenes/surveys/surveysLogic";
import { combineUrl } from "kea-router";
import { examples } from "~/queries/examples";
import { isDataTableNode, isDataVisualizationNode, isHogQLQuery } from "~/queries/utils";
import { toParams } from "lib/utils/url";
import { urls } from "scenes/urls";

/** This const is auto-generated, as is the whole file */
export const productRoutes: Record<string, [string, string]> = {
  "/data-management/actions": ["Actions", "actions"],
  "/data-management/actions/new": ["NewAction", "actionNew"],
  "/data-management/actions/:id": ["Action", "action"],
  "/data-management/actions/new/": ["NewAction", "actionNew"],
  "/ai-gateway": ["AIGateway", "aiGateway"],
  "/ai-observability/dashboard": ["AIObservability", "aiObservabilityDashboard"],
  "/ai-observability/generations": ["AIObservability", "aiObservabilityGenerations"],
  "/ai-observability/reviews": ["AIObservability", "aiObservabilityReviews"],
  "/ai-observability/traces": ["AIObservability", "aiObservabilityTraces"],
  "/ai-observability/traces/:id": ["AIObservabilityTrace", "aiObservability"],
  "/ai-observability/users": ["AIObservability", "aiObservabilityUsers"],
  "/ai-observability/errors": ["AIObservability", "aiObservabilityErrors"],
  "/ai-observability/tools": ["AIObservability", "aiObservabilityTools"],
  "/ai-observability/sentiment": ["AIObservability", "aiObservabilitySentiment"],
  "/ai-observability/sessions": ["AIObservability", "aiObservabilitySessions"],
  "/ai-observability/sessions/:id": ["AIObservability", "aiObservabilitySessions"],
  "/ai-observability/playground": ["AIObservabilityPlayground", "aiObservabilityPlayground"],
  "/ai-observability/clusters": ["AIObservabilityClusters", "aiObservabilityClusters"],
  "/ai-observability/clusters/:runId": ["AIObservabilityClusters", "aiObservabilityClusters"],
  [AI_OBSERVABILITY_CLUSTER_URL_PATTERN]: ["AIObservabilityCluster", "aiObservabilityCluster"],
  "/ai-evals/datasets": ["AIObservabilityDatasets", "aiObservabilityDatasets"],
  "/ai-evals/datasets/:id": ["AIObservabilityDataset", "aiObservabilityDataset"],
  "/ai-evals/taggers": ["AIObservabilityTags", "aiObservabilityTags"],
  "/ai-evals/taggers/:id": ["AIObservabilityTag", "aiObservabilityTag"],
  "/ai-evals/evaluations": ["AIObservabilityEvaluations", "aiObservabilityEvaluations"],
  "/ai-evals/evaluations/offline/experiments": [
    "AIObservabilityEvaluations",
    "aiObservabilityOfflineEvaluations",
  ],
  "/ai-evals/evaluations/offline/experiments/:experimentId": [
    "AIObservabilityEvaluations",
    "aiObservabilityOfflineEvaluationExperiment",
  ],
  "/ai-evals/evaluations/templates": [
    "AIObservabilityEvaluationTemplates",
    "aiObservabilityEvaluationTemplates",
  ],
  "/ai-evals/evaluations/:id": ["AIObservabilityEvaluation", "aiObservabilityEvaluation"],
  "/prompt-management/prompts": ["AIObservabilityPrompts", "aiObservabilityPrompts"],
  "/prompt-management/prompts/:name": ["AIObservabilityPrompt", "aiObservabilityPrompt"],
  "/alerts": ["Alerts", "alerts"],
  "/business-knowledge": ["BusinessKnowledge", "businessKnowledge"],
  "/transformations": ["Transformations", "transformations"],
  "/event-filtering": ["EventFiltering", "eventFiltering"],
  "/feature_flags/staff/cohorts": ["CohortsStaffTools", "cohortsStaffTools"],
  "/support/tickets": ["SupportTickets", "supportTickets"],
  "/support/tickets/:ticketId": ["SupportTicketDetail", "supportTicketDetail"],
  "/support/settings": ["SupportSettings", "supportSettings"],
  "/customer_analytics/dashboard": ["CustomerAnalytics", "customerAnalyticsDashboard"],
  "/customer_analytics/accounts": ["CustomerAnalytics", "customerAnalyticsAccounts"],
  "/customer_analytics/accounts/:accountId": ["CustomerAnalytics", "customerAnalyticsAccounts"],
  "/customer_analytics/accounts/:accountId/:tab": [
    "CustomerAnalytics",
    "customerAnalyticsAccounts",
  ],
  "/customer_analytics/notes": ["CustomerAnalytics", "customerAnalyticsNotes"],
  "/customer_analytics/announcements": ["CustomerAnalytics", "customerAnalyticsAnnouncements"],
  "/customer_analytics/journeys/new": ["CustomerJourneyBuilder", "customerJourneyBuilder"],
  "/customer_analytics/journeys/templates": [
    "CustomerJourneyTemplates",
    "customerJourneyTemplates",
  ],
  "/customer_analytics/journeys/:id/edit": ["CustomerJourneyBuilder", "customerJourneyEdit"],
  "/customer_analytics/journeys": ["CustomerAnalytics", "customerAnalyticsJourneys"],
  "/customer_analytics/configuration": [
    "CustomerAnalyticsConfiguration",
    "customerAnalyticsConfiguration",
  ],
  "/data-catalog": ["DataCatalog", "dataCatalog"],
  "/data-catalog/metrics/:name": ["DataCatalogMetric", "dataCatalogMetric"],
  "/data-ops": ["DataOps", "dataOps"],
  "/models": ["Models", "models"],
  "/models/dags": ["Models", "models"],
  "/models/:id": ["NodeDetail", "nodeDetail"],
  "/data-management/sources": ["Sources", "sources"],
  "/data-management/sources/:sourceId/schemas/:schemaId": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/sources/:sourceId/schemas/:schemaId/:tab": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/sources/:sourceId/schemas/:schemaId/configuration/:section": [
    "DataWarehouseSourceSchema",
    "dataWarehouseSourceSchema",
  ],
  "/data-management/sources/:id/:tab": ["DataWarehouseSource", "dataWarehouseSource"],
  "/data-warehouse/new-source": ["DataWarehouseSourceNew", "dataWarehouseSourceNew"],
  "/data-warehouse/connect": ["DataWarehouseSourceConnect", "dataWarehouseSourceConnect"],
  "/early_access_features": ["EarlyAccessFeatures", "earlyAccessFeatures"],
  "/early_access_features/:id": ["EarlyAccessFeature", "earlyAccessFeature"],
  "/endpoints": ["EndpointsScene", "endpoints"],
  "/endpoints/:name": ["EndpointScene", "endpoint"],
  "/engineering-analytics/overview": ["EngineeringAnalytics", "engineeringAnalytics"],
  "/engineering-analytics/pull-requests": [
    "EngineeringAnalytics",
    "engineeringAnalyticsPullRequestList",
  ],
  "/engineering-analytics/workflows": ["EngineeringAnalytics", "engineeringAnalyticsWorkflows"],
  "/engineering-analytics/test-health": ["EngineeringAnalytics", "engineeringAnalyticsTestHealth"],
  "/engineering-analytics/teams": ["EngineeringAnalytics", "engineeringAnalyticsTeams"],
  "/engineering-analytics/teams/:ownerTeam": [
    "EngineeringAnalyticsTeam",
    "engineeringAnalyticsTeam",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/pull-requests/:number": [
    "EngineeringAnalyticsPullRequest",
    "engineeringAnalyticsPullRequest",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/actions/runs/:runId": [
    "EngineeringAnalyticsWorkflowRun",
    "engineeringAnalyticsWorkflowRun",
  ],
  "/engineering-analytics/repos/:repoOwner/:repoName/actions/workflows/:workflowName": [
    "EngineeringAnalyticsWorkflowRuns",
    "engineeringAnalyticsWorkflowRuns",
  ],
  "/engineering-analytics/authors/:handle": [
    "EngineeringAnalyticsAuthor",
    "engineeringAnalyticsAuthor",
  ],
  "/error_tracking": ["ErrorTracking", "errorTracking"],
  "/error_tracking/fingerprint/*": ["ErrorTrackingFingerprint", "errorTrackingFingerprint"],
  "/error_tracking/:id": ["ErrorTrackingIssue", "errorTrackingIssue"],
  "/error_tracking/:id/fingerprints": [
    "ErrorTrackingIssueFingerprints",
    "errorTrackingIssueFingerprints",
  ],
  "/error_tracking/alerts/:id": ["HogFunction", "errorTrackingAlert"],
  "/error_tracking/alerts/new/:templateId": ["HogFunction", "errorTrackingAlertNew"],
  "/feature_flags/templates": ["FeatureFlagTemplates", "featureFlagTemplates"],
  "/feature_flags/staff": ["FeatureFlagsStaffTools", "featureFlagsStaffTools"],
  "/games/368hedgehogs": ["Game368Hedgehogs", "game368Hedgehogs"],
  "/games/flappyhog": ["FlappyHog", "flappyHog"],
  "/identity-matching": ["IdentityMatching", "identityMatching"],
  "/legal": ["LegalDocuments", "legalDocuments"],
  "/legal/new/:type": ["LegalDocumentNew", "legalDocumentNew"],
  "/links": ["Links", "links"],
  "/link/:id": ["Link", "link"],
  "/live-debugger": ["LiveDebugger", "liveDebugger"],
  "/logs": ["Logs", "logs"],
  "/logs/alerts/:id": ["LogsAlertDetail", "logsAlertDetail"],
  "/logs/alerts/:id/notifications/:hogFunctionId": [
    "LogsAlertNotificationDetail",
    "logsAlertNotificationDetail",
  ],
  "/logs/drop-rules/new": ["LogsSamplingNew", "logsSamplingNew"],
  "/logs/drop-rules/:id": ["LogsSamplingDetail", "logsSamplingDetail"],
  "/managed_migrations": ["ManagedMigration", "managedMigration"],
  "/managed_migrations/new": ["ManagedMigration", "managedMigration"],
  "/mcp-analytics/activity": ["MCPAnalytics", "mcpAnalyticsActivity"],
  "/mcp-analytics/dashboard": ["MCPAnalytics", "mcpAnalyticsDashboard"],
  "/mcp-analytics/sessions": ["MCPAnalytics", "mcpAnalyticsSessions"],
  "/mcp-analytics/tool-quality": ["MCPAnalytics", "mcpAnalyticsToolQuality"],
  "/mcp-analytics/tool-quality/:toolName": ["MCPAnalyticsToolDetail", "mcpAnalyticsTool"],
  "/mcp-analytics/intent-clustering": ["MCPAnalytics", "mcpAnalyticsIntentClustering"],
  "/mcp-analytics/notifications": ["MCPAnalytics", "mcpAnalyticsNotifications"],
  "/metrics": ["Metrics", "metrics"],
  "/tasks": ["TaskTracker", "taskTracker"],
  "/tasks/:taskId": ["TaskTracker", "taskDetail"],
  "/pulse": ["Pulse", "pulse"],
  "/replay-vision": ["ReplayVision", "replayVision"],
  "/replay-vision/observations/:observationId": [
    "ReplayVisionObservation",
    "replayVisionObservation",
  ],
  "/replay-vision/actions/:actionId/runs/:runId": [
    "ReplayVisionActionRun",
    "replayVisionActionRun",
  ],
  "/replay-vision/actions/:actionId/edit": ["ReplayVisionActionEditor", "replayVisionActionEdit"],
  "/replay-vision/actions/:actionId": ["ReplayVisionAction", "replayVisionAction"],
  "/replay-vision/:scannerId/actions/new": ["ReplayVisionActionEditor", "replayVisionActionNew"],
  "/replay-vision/:id/template": ["ReplayVisionScannerEditor", "replayVisionScannerTemplate"],
  "/replay-vision/:id/configure": ["ReplayVisionScannerEditor", "replayVisionScannerConfigure"],
  "/replay-vision/:id/triggers": ["ReplayVisionScannerEditor", "replayVisionScannerTriggers"],
  "/replay-vision/:id/self-driving": [
    "ReplayVisionScannerEditor",
    "replayVisionScannerSelfDriving",
  ],
  "/replay-vision/:id": ["ReplayVisionScanner", "replayVision"],
  "/code-review": ["CodeReview", "codeReview"],
  "/session-summaries": ["SessionGroupSummariesTable", "sessionGroupSummariesTable"],
  "/session-summaries/:sessionGroupId": ["SessionGroupSummary", "sessionGroupSummary"],
  "/skills": ["Skills", "skills"],
  "/skills/scouts": ["Skills", "skillsScouts"],
  "/skills/review-hog": ["Skills", "skillsReviewHog"],
  "/skills/:name": ["Skill", "skill"],
  "/stamphog": ["Stamphog", "stamphog"],
  "/stamphog/install/callback": ["Stamphog", "stamphogCallback"],
  "/streamlit-apps": ["StreamlitApps", "streamlitApps"],
  "/streamlit-apps/new": ["StreamlitAppEdit", "streamlitAppNew"],
  "/streamlit-apps/:id": ["StreamlitApp", "streamlitApp"],
  "/streamlit-apps/:id/edit": ["StreamlitAppEdit", "streamlitAppEdit"],
  "/subscriptions": ["Subscriptions", "subscriptions"],
  "/subscriptions/new": ["Subscriptions", "subscriptionNew"],
  "/subscriptions/:subscriptionId/edit": ["Subscriptions", "subscriptionEdit"],
  "/subscriptions/:subscriptionId": ["Subscription", "subscription"],
  "/slack-task-context": ["SlackTaskContext", "slackTaskContext"],
  "/tracing": ["Tracing", "tracing"],
  "/tracing/operation": ["TracingOperation", "tracingOperation"],
  "/user_research": ["UserInterviews", "userInterviews"],
  "/user_research/:topicId/response/:responseId": [
    "UserInterviewResponse",
    "userInterviewResponse",
  ],
  "/user_research/:id": ["UserInterview", "userInterview"],
  "/visual_review": ["VisualReviewIndex", "visualReviewIndex"],
  "/visual_review/settings": ["VisualReviewSettings", "visualReviewSettings"],
  "/visual_review/runs/:runId": ["VisualReviewRun", "visualReviewRun"],
  "/visual_review/repos/:repoId/runs": ["VisualReviewRuns", "visualReviewRepoRuns"],
  "/visual_review/repos/:repoId/snapshots": [
    "VisualReviewSnapshotOverview",
    "visualReviewSnapshotOverview",
  ],
  "/visual_review/repos/:repoId/:runType/snapshots/:identifier": [
    "VisualReviewSnapshotHistory",
    "visualReviewSnapshotHistory",
  ],
  "/workflows": ["Workflows", "workflows"],
  "/workflows/:tab": ["Workflows", "workflows"],
  "/workflows/:id/:tab": ["Workflow", "workflowTab"],
  "/workflows/library/templates/:id": ["WorkflowsLibraryTemplate", "workflowsLibraryTemplate"],
  "/workflows/library/templates/new": ["WorkflowsLibraryTemplate", "workflowsLibraryTemplate"],
  "/workflows/library/templates/new?messageId=:messageId": [
    "WorkflowsLibraryTemplate",
    "workflowsLibraryTemplateFromMessage",
  ],
};

/** This const is auto-generated, as is the whole file */
export const productRedirects: Record<
  string,
  string | ((params: Params, searchParams: Params, hashParams: Params) => string)
> = {
  "/ai-observability": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/ai-observability/settings": (_params, searchParams, hashParams) => {
    const nextHashParams = { ...hashParams };
    if (Object.prototype.hasOwnProperty.call(nextHashParams, "llm-analytics-byok")) {
      delete nextHashParams["llm-analytics-byok"];
    }
    if (nextHashParams.setting === "llm-analytics-byok") {
      nextHashParams.setting = "ai-observability-byok";
    }
    if (nextHashParams.selectedSetting === "llm-analytics-byok") {
      nextHashParams.selectedSetting = "ai-observability-byok";
    }
    nextHashParams["ai-observability-byok"] = null;
    return combineUrl(urls.settings("project-ai-observability"), searchParams, nextHashParams).url;
  },
  "/ai-evals": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluations(), searchParams, hashParams).url,
  "/ai-evals/evaluations/offline": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/ai-evals/tags": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTags(), searchParams, hashParams).url,
  "/ai-evals/tags/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTag(params.id), searchParams, hashParams).url,
  "/prompt-management": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompts(), searchParams, hashParams).url,
  "/llm-analytics": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-analytics/settings": (_params, searchParams, hashParams) => {
    const nextHashParams = { ...hashParams };
    if (Object.prototype.hasOwnProperty.call(nextHashParams, "llm-analytics-byok")) {
      delete nextHashParams["llm-analytics-byok"];
    }
    if (nextHashParams.setting === "llm-analytics-byok") {
      nextHashParams.setting = "ai-observability-byok";
    }
    if (nextHashParams.selectedSetting === "llm-analytics-byok") {
      nextHashParams.selectedSetting = "ai-observability-byok";
    }
    nextHashParams["ai-observability-byok"] = null;
    return combineUrl(urls.settings("project-ai-observability"), searchParams, nextHashParams).url;
  },
  "/llm-analytics/dashboard": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-analytics/generations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityGenerations(), searchParams, hashParams).url,
  "/llm-analytics/reviews": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityReviews(), searchParams, hashParams).url,
  "/llm-analytics/traces": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTraces(), searchParams, hashParams).url,
  "/llm-analytics/traces/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTrace(params.id), searchParams, hashParams).url,
  "/llm-analytics/users": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityUsers(), searchParams, hashParams).url,
  "/llm-analytics/errors": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityErrors(), searchParams, hashParams).url,
  "/llm-analytics/tools": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTools(), searchParams, hashParams).url,
  "/llm-analytics/sentiment": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySentiment(), searchParams, hashParams).url,
  "/llm-analytics/sessions": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySessions(), searchParams, hashParams).url,
  "/llm-analytics/sessions/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilitySession(params.id), searchParams, hashParams).url,
  "/llm-analytics/playground": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPlayground(), searchParams, hashParams).url,
  "/llm-analytics/clusters": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityClusters(), searchParams, hashParams).url,
  "/llm-analytics/clusters/:runId": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityClusters(params.runId), searchParams, hashParams).url,
  "/llm-analytics/clusters/:runId/:clusterId": (params, searchParams, hashParams) =>
    combineUrl(
      urls.aiObservabilityCluster(params.runId, params.clusterId),
      searchParams,
      hashParams,
    ).url,
  "/llm-analytics/datasets": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDatasets(), searchParams, hashParams).url,
  "/llm-analytics/datasets/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDataset(params.id), searchParams, hashParams).url,
  "/llm-analytics/tags": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTags(), searchParams, hashParams).url,
  "/llm-analytics/tags/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTag(params.id), searchParams, hashParams).url,
  "/llm-analytics/evaluations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline/experiments": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityOfflineEvaluations(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/offline/experiments/:experimentId": (
    params,
    searchParams,
    hashParams,
  ) =>
    combineUrl(
      urls.aiObservabilityOfflineEvaluationExperiment(params.experimentId),
      searchParams,
      hashParams,
    ).url,
  "/llm-analytics/evaluations/templates": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluationTemplates(), searchParams, hashParams).url,
  "/llm-analytics/evaluations/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityEvaluation(params.id), searchParams, hashParams).url,
  "/llm-analytics/prompts": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompts(), searchParams, hashParams).url,
  "/llm-analytics/prompts/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPrompt(params.name), searchParams, hashParams).url,
  "/llm-observability": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-observability/dashboard": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityDashboard(), searchParams, hashParams).url,
  "/llm-observability/generations": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityGenerations(), searchParams, hashParams).url,
  "/llm-observability/reviews": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityReviews(), searchParams, hashParams).url,
  "/llm-observability/traces": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTraces(), searchParams, hashParams).url,
  "/llm-observability/traces/:id": (params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityTrace(params.id), searchParams, hashParams).url,
  "/llm-observability/users": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityUsers(), searchParams, hashParams).url,
  "/llm-observability/playground": (_params, searchParams, hashParams) =>
    combineUrl(urls.aiObservabilityPlayground(), searchParams, hashParams).url,
  "/support": "/support/tickets",
  "/customer_analytics": (_params, searchParams, hashParams) => {
    const defaultTab = posthog.getFeatureFlag(FEATURE_FLAGS.CUSTOMER_ANALYTICS_CSP)
      ? "/customer_analytics/accounts"
      : "/customer_analytics/dashboard";
    return combineUrl(defaultTab, searchParams, hashParams).url;
  },
  "/data-warehouse": () => urls.sources(),
  "/data-warehouse/sources": () => urls.sources(),
  "/data-warehouse/sources/:id": ({ id }) => urls.dataWarehouseSource(id, "schemas"),
  "/data-warehouse/sources/:id/:tab": ({ id, tab }) =>
    urls.dataWarehouseSource(id, tab as SourceSceneTab),
  "/engineering-analytics": "/engineering-analytics/overview",
  "/engineering-analytics/authors": "/engineering-analytics/overview",
  "/error_tracking/configuration": (_params, searchParams, hashParams) => {
    const { tab, ...restSearchParams } = searchParams;
    return combineUrl(
      "/error_tracking",
      { ...restSearchParams, activeTab: "configuration" },
      { ...hashParams, ...(tab ? { selectedSetting: tab } : {}) },
    ).url;
  },
  "/logs/sampling/new": (_params, searchParams, hashParams) =>
    combineUrl("/logs/drop-rules/new", searchParams, hashParams).url,
  "/logs/sampling/:id": (params, searchParams, hashParams) =>
    combineUrl(`/logs/drop-rules/${params.id}`, searchParams, hashParams).url,
  "/mcp-analytics": (_params, searchParams, hashParams) =>
    combineUrl(urls.mcpAnalyticsDashboard(), { ...searchParams, landing: "auto" }, hashParams).url,
  "/replay-vision/templates": "/replay-vision/new/template",
  "/prompt-management/skills": (_params, searchParams, hashParams) =>
    combineUrl(urls.skills(), searchParams, hashParams).url,
  "/prompt-management/skills/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.skill(params.name), searchParams, hashParams).url,
  "/llm-analytics/skills": (_params, searchParams, hashParams) =>
    combineUrl(urls.skills(), searchParams, hashParams).url,
  "/llm-analytics/skills/:name": (params, searchParams, hashParams) =>
    combineUrl(urls.skill(params.name), searchParams, hashParams).url,
  "/user_interviews": "/user_research",
};

/** This const is auto-generated, as is the whole file */
export const productConfiguration: Record<string, any> = {
  Actions: {
    name: "Actions",
    projectBased: true,
    activityScope: "Action",
    description:
      "Combine several related events into one, which you can then analyze in insights and dashboards as if it were a single event.",
    iconType: "action",
  },
  Action: { name: "Action", projectBased: true, activityScope: "Action", iconType: "action" },
  NewAction: {
    name: "New Action",
    projectBased: true,
    activityScope: "Action",
    iconType: "action",
  },
  AIGateway: {
    projectBased: true,
    name: "AI gateway",
    description:
      "Every major LLM through one endpoint, billed at cost \u2014 usage tracked per project.",
    layout: "app-container",
    iconType: "ai_gateway",
  },
  AIObservability: {
    projectBased: true,
    name: "AI observability",
    layout: "app-container",
    description: "Analyze and understand your AI usage and performance.",
    iconType: "llm_analytics",
  },
  AIObservabilityTrace: {
    projectBased: true,
    name: "AI observability trace",
    layout: "app-container",
  },
  AIObservabilitySession: {
    projectBased: true,
    name: "AI observability session",
    layout: "app-container",
  },
  AIObservabilityUsers: {
    projectBased: true,
    name: "AI observability users",
    layout: "app-container",
  },
  AIObservabilityPlayground: {
    projectBased: true,
    name: "Playground",
    description: "Test and experiment with LLM prompts in a sandbox environment.",
    layout: "app-full-scene-height",
    iconType: "llm_playground",
  },
  AIObservabilityDatasets: {
    projectBased: true,
    name: "Datasets",
    description: "Manage datasets for testing and evaluation.",
    layout: "app-container",
    iconType: "llm_datasets",
  },
  AIObservabilityDataset: {
    projectBased: true,
    name: "Dataset",
    layout: "app-container",
    iconType: "llm_datasets",
  },
  AIObservabilityEvaluations: {
    projectBased: true,
    name: "Evaluations",
    description: "Configure and monitor automated LLM output evaluations.",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityEvaluation: {
    projectBased: true,
    name: "Evaluation",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityEvaluationTemplates: {
    projectBased: true,
    name: "Evaluation templates",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_evaluations",
  },
  AIObservabilityTags: {
    projectBased: true,
    name: "Taggers",
    description: "Add custom tags to your AI generations automatically.",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_tags",
  },
  AIObservabilityTag: {
    projectBased: true,
    name: "Tagger",
    activityScope: "AIObservability",
    layout: "app-container",
    iconType: "llm_tags",
  },
  AIObservabilityPrompts: {
    projectBased: true,
    name: "Prompts",
    description: "Track and manage your LLM prompts.",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  AIObservabilityPrompt: {
    projectBased: true,
    name: "Prompt",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  AIObservabilityClusters: {
    projectBased: true,
    name: "Clusters",
    description: "Discover patterns and clusters in your AI usage.",
    layout: "app-container",
    iconType: "llm_clusters",
  },
  AIObservabilityCluster: {
    projectBased: true,
    name: "AI observability cluster",
    layout: "app-container",
    iconType: "llm_clusters",
  },
  Alerts: {
    projectBased: true,
    name: "Alerts",
    iconType: "inbox",
    description: "Monitor insight metrics and get notified when conditions are met.",
  },
  BusinessKnowledge: {
    name: "Business knowledge",
    projectBased: true,
    activityScope: "KnowledgeSource",
    description:
      "Upload text, public URLs, or files so PostHog AI can understand your business context, vision, and policies.",
  },
  Transformations: {
    projectBased: true,
    name: "Transformations",
    description:
      "Transformations let you modify, filter, and enrich event data to improve data quality, privacy, and consistency.",
    activityScope: "HogFunction",
    iconType: "data_pipeline",
  },
  EventFiltering: {
    projectBased: true,
    name: "Event ingestion filtering",
    description: "Drop events at ingestion time based on event metadata.",
    iconType: "data_pipeline",
  },
  CohortsStaffTools: { instanceLevel: true, name: "Cohorts staff tools" },
  SupportTickets: { name: "Ticket list", projectBased: true, layout: "app-container" },
  SupportTicketDetail: { name: "Ticket detail", projectBased: true, layout: "app-container" },
  SupportSettings: { name: "Support settings", projectBased: true, layout: "app-container" },
  CustomerAnalytics: {
    projectBased: true,
    name: "Customer analytics",
    description: "Understand how your customers interact with your product ",
    iconType: "cohort",
  },
  CustomerAnalyticsConfiguration: { projectBased: true, name: "Customer analytics configuration" },
  CustomerJourneyBuilder: { projectBased: true, name: "New journey" },
  CustomerJourneyTemplates: { projectBased: true, name: "New journey" },
  DataCatalog: {
    projectBased: true,
    name: "Data catalog",
    layout: "app-container",
    iconType: "data_warehouse",
    description:
      "Review and manage governed metrics, certifications, and relationships for your data.",
  },
  DataCatalogMetric: { projectBased: true, name: "Metric" },
  DataOps: {
    name: "Data ops",
    projectBased: true,
    activityScope: "DataWarehouse",
    description: "Manage your organization's shared data warehouse.",
    iconType: "data_warehouse",
  },
  Models: {
    name: "Models",
    projectBased: true,
    description:
      "Create and manage views and materialized views for transforming and organizing your data.",
    iconType: "sql_editor",
  },
  NodeDetail: { name: "Model detail", projectBased: true },
  SQLEditor: {
    projectBased: true,
    name: "SQL editor",
    layout: "app-raw-no-header",
    hideProjectNotice: true,
    description: "Write and execute SQL queries against your data warehouse",
  },
  Sources: {
    projectBased: true,
    name: "Sources",
    description:
      "Import data into PostHog from external sources including webhooks, application connectors, and self-managed databases.",
    activityScope: ActivityScope.HOG_FUNCTION,
    iconType: "data_pipeline",
  },
  DataWarehouseSource: { projectBased: true, name: "Data warehouse source" },
  DataWarehouseSourceNew: { projectBased: true, name: "New data warehouse source" },
  DataWarehouseSourceConnect: { projectBased: true, name: "Connect data warehouse source" },
  DataWarehouseSourceSchema: { projectBased: true, name: "Data warehouse schema" },
  EarlyAccessFeatures: {
    name: "Early access features",
    projectBased: true,
    description:
      "Allow your users to individually enable or disable features that are in public beta.",
    iconType: "early_access_feature",
  },
  EarlyAccessFeature: { name: "Early access feature", projectBased: true },
  EndpointsScene: {
    projectBased: true,
    name: "Endpoints",
    activityScope: "Endpoints",
    layout: "app-container",
    iconType: "endpoints",
    description:
      "Define queries your application will use via the API and monitor their cost and usage.",
  },
  EndpointScene: { projectBased: true, name: "Endpoint", activityScope: "Endpoint" },
  EngineeringAnalytics: {
    projectBased: true,
    name: "Engineering analytics",
    layout: "app-container",
    description: "Pull request and workflow CI health across connected GitHub repos.",
    iconType: "health",
  },
  EngineeringAnalyticsPullRequest: {
    projectBased: true,
    name: "Pull request",
    layout: "app-container",
    description: "A single pull request: lifecycle milestones and CI runs on its head commit.",
    iconType: "health",
  },
  EngineeringAnalyticsWorkflowRun: {
    projectBased: true,
    name: "Workflow run",
    layout: "app-container",
    description:
      "A single workflow run: status, duration, branch, and the attributed pull request.",
    iconType: "health",
  },
  EngineeringAnalyticsWorkflowRuns: {
    projectBased: true,
    name: "Workflow runs",
    layout: "app-container",
    description: "A single workflow's recent runs across the connected repo.",
    iconType: "health",
  },
  EngineeringAnalyticsAuthor: {
    projectBased: true,
    name: "Author",
    layout: "app-container",
    description:
      "One author's pull requests \u2014 a filtered view for finding work, not a ranking.",
    iconType: "health",
  },
  EngineeringAnalyticsTeam: {
    projectBased: true,
    name: "Team CI health",
    layout: "app-container",
    description: "One owning team's merge timing and the before/after signal on its owned tests.",
    iconType: "health",
  },
  ErrorTracking: {
    projectBased: true,
    name: "Error tracking",
    iconType: "error_tracking",
    description: "Track and analyze your error tracking data to understand and fix issues.",
  },
  ErrorTrackingIssue: { projectBased: true, name: "Error tracking issue", layout: "app-raw" },
  ErrorTrackingIssueFingerprints: { projectBased: true, name: "Error tracking issue fingerprints" },
  ErrorTrackingFingerprint: { projectBased: true, name: "Error tracking fingerprint" },
  FeatureFlagTemplates: { projectBased: true, name: "Feature flag templates" },
  FeatureFlagsStaffTools: { instanceLevel: true, name: "Flags staff tools" },
  Game368Hedgehogs: { name: "368Hedgehogs", projectBased: true, activityScope: "Games" },
  FlappyHog: { name: "FlappyHog", projectBased: true, activityScope: "Games" },
  IdentityMatching: {
    name: "Identity matching",
    projectBased: true,
    activityScope: "IdentityMatching",
    description:
      "Review probable links between anonymous visitors and identified persons, recovered from first-party signals.",
    iconType: "persons",
  },
  LegalDocuments: {
    name: "Legal documents",
    organizationBased: true,
    activityScope: "LegalDocument",
    description:
      "Generate a Business Associate Agreement or Data Processing Agreement for your organization.",
  },
  LegalDocumentNew: {
    name: "New legal document",
    organizationBased: true,
    activityScope: "LegalDocument",
  },
  Links: {
    name: "Links",
    projectBased: true,
    activityScope: "Link",
    description: "Start creating links for your marketing campaigns, referral programs, and more.",
    iconType: "link",
  },
  Link: { name: "Link", projectBased: true, activityScope: "Link" },
  LiveDebugger: { name: "Live Debugger", projectBased: true },
  Logs: {
    projectBased: true,
    name: "Logs",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
    iconType: "logs",
    description: "Monitor and analyze your logs to understand and fix issues.",
  },
  LogsAlertDetail: {
    projectBased: true,
    name: "Alert",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsAlertNotificationDetail: {
    projectBased: true,
    name: "Destination",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsSamplingNew: {
    projectBased: true,
    name: "New drop rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  LogsSamplingDetail: {
    projectBased: true,
    name: "Drop rule",
    activityScope: ActivityScope.LOG,
    layout: "app-container",
  },
  ManagedMigration: {
    name: "Managed migrations",
    description:
      "Managed migrations provide an automated way to migrate your historical data into PostHog.",
    projectBased: true,
  },
  ManagedMigrationNew: { name: "Managed migrations", projectBased: true },
  MCPAnalytics: {
    projectBased: true,
    name: "MCP analytics",
    layout: "app-container",
    description:
      "Capture user intent and behaviour patterns to understand what AI users need from your tools.",
    iconType: "mcp_analytics",
  },
  MCPAnalyticsToolDetail: {
    projectBased: true,
    name: "MCP tool",
    layout: "app-container",
    iconType: "mcp_analytics",
  },
  Metrics: {
    name: "Metrics",
    projectBased: true,
    layout: "app-container",
    activityScope: "Metrics",
    description:
      "Monitor and analyze application metrics to understand system performance and health.",
    iconType: "metrics",
  },
  TaskTracker: {
    name: "Tasks",
    projectBased: true,
    activityScope: "TaskTracker",
    description:
      "Tasks are work that agents can do for you, like creating a pull request or fixing an issue.",
    iconType: "task",
    layout: "app-full-scene-height",
  },
  Pulse: {
    name: "Pulse",
    projectBased: true,
    description:
      "Your always-on product manager: spots growth opportunities and shows how to move the numbers that matter.",
    iconType: "activity",
  },
  ReplayVision: {
    name: "Replay vision",
    projectBased: true,
    description:
      "Set up AI scanners that automatically analyze new session recordings as they come in. Each result emits a queryable event.",
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionScanner: {
    name: "Replay vision scanner",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionScannerEditor: {
    name: "Replay vision scanner editor",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionObservation: {
    name: "Replay vision observation",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionAction: {
    name: "Replay vision action",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionActionEditor: {
    name: "Replay vision action editor",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  ReplayVisionActionRun: {
    name: "Replay vision action run",
    projectBased: true,
    iconType: "replay_vision",
    layout: "app-container",
  },
  CodeReview: {
    name: "Code review",
    projectBased: true,
    description: "Automated code reviews of your pull requests, and your review agent settings.",
    iconType: "code_review",
  },
  SessionGroupSummariesTable: {
    name: "Session summaries",
    projectBased: true,
    description:
      "View and deep-dive into AI-generated summaries of session recordings. Create summaries from the Session replay page by applying filters and asking PostHog AI to summarize sessions.",
    iconType: "notebook",
  },
  SessionGroupSummary: {
    name: "Session summary",
    projectBased: true,
    description: "View detailed session group summary.",
    iconType: "notebook",
  },
  Skills: {
    projectBased: true,
    name: "Skills",
    description: "Manage versioned agent skills that any MCP-connected agent can discover and use.",
    layout: "app-container",
    iconType: "llm_prompts",
  },
  Skill: { projectBased: true, name: "Skill", layout: "app-container", iconType: "llm_prompts" },
  Stamphog: { projectBased: true, name: "Stamphog", iconType: "stamphog" },
  StreamlitApps: { name: "Streamlit apps", projectBased: true },
  StreamlitApp: { name: "Streamlit app", projectBased: true },
  StreamlitAppEdit: { name: "Edit Streamlit app", projectBased: true },
  Subscriptions: {
    projectBased: true,
    name: "Subscriptions",
    iconType: "inbox",
    description: "View and manage scheduled insight and dashboard subscriptions for this project.",
  },
  Subscription: {
    projectBased: true,
    name: "Subscription",
    iconType: "inbox",
    description: "View subscription details and delivery history for this project.",
  },
  SlackTaskContext: { name: "Slack task context", projectBased: true },
  Toolbar: {
    name: "Toolbar",
    projectBased: true,
    description: "PostHog toolbar launches PostHog right in your app or website.",
    iconType: "toolbar",
  },
  Tracing: {
    name: "Tracing",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    description:
      "Monitor and analyze distributed traces to understand service performance and debug issues.",
    iconType: "tracing",
  },
  TracingOperation: {
    name: "Operation",
    projectBased: true,
    layout: "app-container",
    activityScope: "Tracing",
    description: "Latency distribution and sample traces for a single operation.",
    iconType: "tracing",
  },
  UserInterviews: {
    name: "User research",
    projectBased: true,
    activityScope: "UserInterview",
    description: "Run AI-powered voice research campaigns to gather user insights at scale.",
    iconType: "user_interview",
  },
  UserInterview: { name: "Interview topic", projectBased: true, activityScope: "UserInterview" },
  UserInterviewResponse: {
    name: "Interview response",
    projectBased: true,
    activityScope: "UserInterview",
  },
  VisualReviewIndex: { name: "Visual review", projectBased: true, iconType: "visual_review" },
  VisualReviewRuns: { name: "Runs", projectBased: true, iconType: "visual_review" },
  VisualReviewRun: { name: "Visual review run", projectBased: true, iconType: "visual_review" },
  VisualReviewSettings: {
    name: "Visual review settings",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewSnapshotHistory: {
    name: "Visual review snapshot history",
    projectBased: true,
    iconType: "visual_review",
  },
  VisualReviewSnapshotOverview: {
    name: "Snapshots",
    projectBased: true,
    iconType: "visual_review",
  },
  Workflows: {
    name: "Workflows",
    iconType: "workflows",
    projectBased: true,
    description: "Automate user communication and internal processes",
  },
  Workflow: { name: "Workflows", iconType: "workflows", projectBased: true },
  WorkflowsLibraryTemplate: { name: "Workflows", iconType: "workflows", projectBased: true },
};

/** This const is auto-generated, as is the whole file */
export const productUrls = {
  createAction: (): string => `/data-management/actions/new`,
  duplicateAction: (action: ActionType | null): string => {
    const queryParams = action ? `?copy=${encodeURIComponent(JSON.stringify(action))}` : "";
    return `/data-management/actions/new/${queryParams}`;
  },
  action: (id: string | number): string => `/data-management/actions/${id}`,
  actions: (): string => "/data-management/actions",
  aiGateway: (): string => "/ai-gateway",
  aiObservabilityDashboard: (): string => "/ai-observability/dashboard",
  aiObservabilityGenerations: (): string => "/ai-observability/generations",
  aiObservabilityReviews: (): string => "/ai-observability/reviews",
  aiObservabilityTraces: (): string => "/ai-observability/traces",
  aiObservabilityTrace: (
    id: string,
    params?: {
      event?: string;
      timestamp?: string;
      exception_ts?: string;
      search?: string;
      tab?: string;
      msg?: string;
    },
  ): string => {
    const encodePathSegment = (value: string): string => {
      const encodedValue = encodeURIComponent(value).replace(
        /[!'()*]/g,
        (character) => `%${character.charCodeAt(0).toString(16).toUpperCase()}`,
      );
      return encodeURIComponent(encodedValue).replace(
        /[!'()*]/g,
        (character) => `%${character.charCodeAt(0).toString(16).toUpperCase()}`,
      );
    };
    const queryParams = new URLSearchParams(params);
    const stringifiedParams = queryParams.toString();
    return `/ai-observability/traces/${encodePathSegment(id)}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  aiObservabilityUsers: (): string => "/ai-observability/users",
  aiObservabilityErrors: (): string => "/ai-observability/errors",
  aiObservabilityTools: (): string => "/ai-observability/tools",
  aiObservabilitySentiment: (): string => "/ai-observability/sentiment",
  aiObservabilitySessions: (): string => "/ai-observability/sessions",
  aiObservabilitySession: (
    id: string,
    params?: {
      timestamp?: string;
    },
  ): string => {
    const queryParams = new URLSearchParams(params);
    const stringifiedParams = queryParams.toString();
    return `/ai-observability/sessions/${id}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  aiObservabilityPlayground: (): string => "/ai-observability/playground",
  aiObservabilityDatasets: (): string => "/ai-evals/datasets",
  aiObservabilityDataset: (
    id: string,
    params?: {
      item?: string;
    },
  ): string => combineUrl(`/ai-evals/datasets/${id}`, params).url,
  aiObservabilityTags: (): string => "/ai-evals/taggers",
  aiObservabilityTag: (id: string): string => `/ai-evals/taggers/${id}`,
  aiObservabilityEvaluations: (): string => "/ai-evals/evaluations",
  aiObservabilityOfflineEvaluations: (): string => "/ai-evals/evaluations/offline/experiments",
  aiObservabilityOfflineEvaluationExperiment: (
    experimentId: string,
    encode: boolean = true,
  ): string =>
    `/ai-evals/evaluations/offline/experiments/${encode ? encodeURIComponent(experimentId) : experimentId}`,
  aiObservabilityEvaluationTemplates: (): string => "/ai-evals/evaluations/templates",
  aiObservabilityEvaluation: (id: string): string => `/ai-evals/evaluations/${id}`,
  aiObservabilityPrompts: (): string => "/prompt-management/prompts",
  aiObservabilityPrompt: (name: string): string => `/prompt-management/prompts/${name}`,
  aiObservabilityClusters: (runId?: string): string =>
    runId
      ? `/ai-observability/clusters/${encodeURIComponent(runId)}`
      : "/ai-observability/clusters",
  aiObservabilityCluster: (runId: string, clusterId: number | string): string =>
    `/ai-observability/clusters/${encodeURIComponent(runId)}/${clusterId}`,
  alert: (alertId: string): string => `/alerts?alert_type=insights&alert_id=${alertId}`,
  alerts: (): string => "/alerts",
  businessKnowledge: (): string => "/business-knowledge",
  transformations: (): string => "/transformations",
  eventFiltering: (): string => "/event-filtering",
  cohort: (id: string | number): string => `/cohorts/${id}`,
  cohorts: (): string => "/cohorts",
  cohortCalculationHistory: (id: string | number): string => `/cohorts/${id}/calculation-history`,
  cohortsStaffTools: (cohortId?: number): string =>
    `/feature_flags/staff/cohorts${cohortId ? `?cohort_id=${cohortId}` : ""}`,
  supportDashboard: (): string => "/support",
  supportTickets: (): string => "/support/tickets",
  supportTicketDetail: (ticketId: string | number): string => `/support/tickets/${ticketId}`,
  supportSettings: (): string => "/support/settings",
  customerAnalytics: (): string => "/customer_analytics",
  customerAnalyticsDashboard: (): string => "/customer_analytics/dashboard",
  customerAnalyticsAccounts: (): string => "/customer_analytics/accounts",
  customerAnalyticsAccount: (accountId: string, tab?: string): string =>
    `/customer_analytics/accounts/${accountId}${tab ? `/${tab}` : ""}`,
  customerAnalyticsNotes: (): string => "/customer_analytics/notes",
  customerAnalyticsAnnouncements: (): string => "/customer_analytics/announcements",
  customerAnalyticsJourneys: (): string => "/customer_analytics/journeys",
  customerAnalyticsConfiguration: (tab?: string): string =>
    `/customer_analytics/configuration${tab ? `?tab=${tab}` : ""}`,
  customerJourneyBuilder: (): string => "/customer_analytics/journeys/new",
  customerJourneyTemplates: (): string => "/customer_analytics/journeys/templates",
  customerJourneyEdit: (id: string): string => `/customer_analytics/journeys/${id}/edit`,
  dashboards: (): string => "/dashboard",
  dashboard: (id: string | number, highlightInsightId?: string): string =>
    combineUrl(`/dashboard/${id}`, highlightInsightId ? { highlightInsightId } : {}).url,
  dashboardTextTile: (id: string | number, textTileId: string | number): string =>
    `${urls.dashboard(id)}/text-tiles/${textTileId}`,
  dashboardButtonTile: (id: string | number, buttonTileId: string | number): string =>
    `${urls.dashboard(id)}/button-tiles/${buttonTileId}`,
  dashboardSharing: (id: string | number): string => `/dashboard/${id}/sharing`,
  dashboardSubscriptions: (id: string | number): string => `/dashboard/${id}/subscriptions`,
  dashboardSubscription: (id: string | number, subscriptionId: string): string =>
    `/dashboard/${id}/subscriptions/${subscriptionId}`,
  sharedDashboard: (shareToken: string): string => `/shared_dashboard/${shareToken}`,
  dataCatalog: (tab?: string): string => `/data-catalog${tab ? `?tab=${tab}` : ""}`,
  dataCatalogMetric: (name: string): string => `/data-catalog/metrics/${name}`,
  dataOps: (tab?: string, dagId?: string): string => {
    const params = new URLSearchParams();
    if (tab) {
      params.set("tab", tab);
    }
    if (dagId) {
      params.set("dag", dagId);
    }
    const query = params.toString();
    return query ? `/data-ops?${query}` : "/data-ops";
  },
  models: (tab?: ModelsSceneTab): string => `/models${tab ? `/${tab}` : ""}`,
  nodeDetail: (id: string): string => `/models/${id}`,
  sources: (): string => "/data-management/sources",
  dataWarehouseSource: (id: string, tab?: SourceSceneTab): string =>
    `/data-management/sources/${id}/${tab ?? "schemas"}`,
  dataWarehouseSourceSchema: (
    sourceId: string,
    schemaId: string,
    tab?: SchemaSceneTab,
    section?: SchemaConfigurationSection,
  ): string => {
    const base = `/data-management/sources/${sourceId}/schemas/${schemaId}`;
    if (tab === "configuration" && section) {
      return `${base}/configuration/${section}`;
    }
    return tab ? `${base}/${tab}` : base;
  },
  dataWarehouseSourceNew: (
    kind?: string,
    returnUrl?: string,
    returnLabel?: string,
    accessMethod?: "warehouse" | "direct",
  ): string => {
    const params = new URLSearchParams();
    if (kind) {
      params.set("kind", kind);
    }
    if (returnUrl) {
      params.set("returnUrl", returnUrl);
    }
    if (returnLabel) {
      params.set("returnLabel", returnLabel);
    }
    if (accessMethod) {
      params.set("access_method", accessMethod);
    }
    const queryString = params.toString();
    return `/data-warehouse/new-source${queryString ? `?${queryString}` : ""}`;
  },
  dataWarehouseSourceConnect: (kind?: string): string =>
    `/data-warehouse/connect${kind ? `?kind=${encodeURIComponent(kind)}` : ""}`,
  earlyAccessFeatures: (): string => "/early_access_features",
  earlyAccessFeature: (id: string): string => `/early_access_features/${id}`,
  endpoints: (): string => "/endpoints",
  endpoint: (name: string, version?: number): string => {
    const searchParams: Record<string, string> = {};
    if (version) {
      searchParams.version = String(version);
    }
    return combineUrl(`/endpoints/${name}`, searchParams).url;
  },
  endpointsUsage: (params?: {
    endpointFilter?: string[];
    dateFrom?: string;
    dateTo?: string;
    materializationType?: "materialized" | "inline";
    interval?: string;
    breakdownBy?: string;
  }): string => {
    if (!params) {
      return "/endpoints?tab=usage";
    }
    const searchParams: Record<string, string> = {};
    if (params.endpointFilter?.length) {
      searchParams.endpointFilter = params.endpointFilter.join(",");
    }
    if (params.dateFrom) {
      searchParams.dateFrom = params.dateFrom;
    }
    if (params.dateTo) {
      searchParams.dateTo = params.dateTo;
    }
    if (params.materializationType) {
      searchParams.materializationType = params.materializationType;
    }
    if (params.interval) {
      searchParams.interval = params.interval;
    }
    if (params.breakdownBy) {
      searchParams.breakdownBy = params.breakdownBy;
    }
    return combineUrl("/endpoints", { tab: "usage", ...searchParams }).url;
  },
  engineeringAnalytics: (): string => "/engineering-analytics/overview",
  engineeringAnalyticsPullRequestList: (): string => "/engineering-analytics/pull-requests",
  engineeringAnalyticsWorkflows: (): string => "/engineering-analytics/workflows",
  engineeringAnalyticsTestHealth: (): string => "/engineering-analytics/test-health",
  engineeringAnalyticsTeams: (): string => "/engineering-analytics/teams",
  engineeringAnalyticsTeam: (ownerTeam: string): string =>
    `/engineering-analytics/teams/${encodeURIComponent(ownerTeam)}`,
  engineeringAnalyticsPullRequest: (
    repoOwner: string,
    repoName: string,
    number: number | string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/pull-requests/${number}`,
  engineeringAnalyticsWorkflowRun: (
    repoOwner: string,
    repoName: string,
    runId: number | string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/actions/runs/${runId}`,
  engineeringAnalyticsWorkflowRuns: (
    repoOwner: string,
    repoName: string,
    workflowName: string,
  ): string =>
    `/engineering-analytics/repos/${encodeURIComponent(repoOwner)}/${encodeURIComponent(repoName)}/actions/workflows/${encodeURIComponent(workflowName)}`,
  engineeringAnalyticsAuthor: (handle: string): string =>
    `/engineering-analytics/authors/${encodeURIComponent(handle)}`,
  errorTracking: (params = {}): string => combineUrl("/error_tracking", params).url,
  errorTrackingConfiguration: (params = {}): string =>
    combineUrl("/error_tracking", { ...params, activeTab: "configuration" }).url,
  errorTrackingIssue: (
    id: string,
    params: {
      timestamp?: string;
      fingerprint?: string;
      searchQuery?: string;
      dateRange?: DateRange;
      filterGroup?: UniversalFiltersGroup;
      utm_source?: string;
      utm_campaign?: string;
      utm_medium?: string;
    } = {},
  ): string => combineUrl(`/error_tracking/${id}`, params).url,
  errorTrackingIssueFingerprints: (id: string): string => `/error_tracking/${id}/fingerprints`,
  errorTrackingFingerprint: (
    fingerprint: string,
    params: {
      timestamp?: string;
    } = {},
  ): string =>
    combineUrl(`/error_tracking/fingerprint/${encodeURIComponent(fingerprint)}`, params).url,
  errorTrackingAlert: (id: string): string => `/error_tracking/alerts/${id}`,
  errorTrackingAlertNew: (templateId: string): string => `/error_tracking/alerts/new/${templateId}`,
  experiment: (
    id: string | number,
    formMode?: string | null,
    options?: {
      metric?: ExperimentMetric;
      name?: string;
    },
  ): string => {
    const baseUrl = formMode ? `/experiments/${id}/${formMode}` : `/experiments/${id}`;
    return `${baseUrl}${options ? `?${toParams(options)}` : ""}`;
  },
  experiments: (): string => "/experiments",
  experimentsSharedMetrics: (): string => "/experiments/shared-metrics",
  experimentsSharedMetric: (id: string | number, action?: string): string =>
    action ? `/experiments/shared-metrics/${id}/${action}` : `/experiments/shared-metrics/${id}`,
  featureFlag: (id: string | number): string => `/feature_flags/${id}`,
  featureFlags: (tab?: string): string => `/feature_flags${tab ? `?tab=${tab}` : ""}`,
  featureFlagTemplates: (): string => "/feature_flags/templates",
  featureFlagsStaffTools: (teamId?: number): string =>
    `/feature_flags/staff${teamId ? `?team_id=${teamId}` : ""}`,
  featureFlagNew: ({
    type,
    sourceId,
    template,
    intent,
  }: {
    type?: "boolean" | "multivariate" | "remote_config";
    sourceId?: number | string | null;
    template?: "simple" | "targeted" | "multivariate" | "targeted-multivariate";
    intent?: "local-eval" | "first-page-load";
  }): string => {
    const params = new URLSearchParams();
    if (type) {
      params.set("type", type);
    }
    if (sourceId) {
      params.set("sourceId", sourceId.toString());
    }
    if (template) {
      params.set("template", template);
    }
    if (intent) {
      params.set("intent", intent);
    }
    return `/feature_flags/new?${params.toString()}`;
  },
  game368hedgehogs: (): string => `/games/368hedgehogs`,
  flappyHog: (): string => `/games/flappyhog`,
  groups: (groupTypeIndex: string | number): string => `/groups/${groupTypeIndex}`,
  groupsNew: (groupTypeIndex: string | number): string => `/groups/${groupTypeIndex}/new`,
  group: (
    groupTypeIndex: string | number,
    groupKey: string,
    encode: boolean = true,
    tab?: string | null,
  ): string =>
    `/groups/${groupTypeIndex}/${encode ? encodeURIComponent(groupKey) : groupKey}${tab ? `/${tab}` : ""}`,
  identityMatching: (): string => "/identity-matching",
  legalDocuments: (): string => "/legal",
  legalDocumentNew: (type: "BAA" | "DPA"): string => `/legal/new/${type.toLowerCase()}`,
  links: (): string => "/links",
  link: (id: string): string => `/link/${id}`,
  liveDebugger: (): string => "/live-debugger",
  logs: (): string => "/logs",
  logsAlertDetail: (id: string, tab?: string): string =>
    tab ? `/logs/alerts/${id}?tab=${tab}` : `/logs/alerts/${id}`,
  logsAlertNotificationDetail: (alertId: string, hogFunctionId: string): string =>
    `/logs/alerts/${alertId}/notifications/${hogFunctionId}`,
  logsSamplingNew: (): string => "/logs/drop-rules/new",
  logsSamplingDetail: (id: string): string => `/logs/drop-rules/${id}`,
  managedMigration: (): string => "/managed_migrations",
  managedMigrationNew: (): string => "/managed_migrations/new",
  marketingAnalyticsApp: (): string => "/marketing",
  mcpAnalyticsActivity: (): string => "/mcp-analytics/activity",
  mcpAnalyticsDashboard: (): string => "/mcp-analytics/dashboard",
  mcpAnalyticsSessions: (): string => "/mcp-analytics/sessions",
  mcpAnalyticsToolQuality: (): string => "/mcp-analytics/tool-quality",
  mcpAnalyticsTool: (toolName: string): string =>
    `/mcp-analytics/tool-quality/${encodeURIComponent(toolName)}`,
  mcpAnalyticsIntentClustering: (): string => "/mcp-analytics/intent-clustering",
  mcpAnalyticsNotifications: (): string => "/mcp-analytics/notifications",
  metrics: (): string => "/metrics",
  notebooks: (): string => "/notebooks",
  notebook: (shortId: string): string => `/notebooks/${shortId}`,
  canvas: (): string => `/canvas`,
  personByDistinctId: (id: string, encode: boolean = true): string =>
    encode ? `/person/${encodeURIComponent(id)}` : `/person/${id}`,
  personByUUID: (uuid: string, encode: boolean = true): string =>
    encode ? `/persons/${encodeURIComponent(uuid)}` : `/persons/${uuid}`,
  persons: (): string => "/persons",
  taskTracker: (): string => "/tasks",
  taskDetail: (taskId: string | number): string => `/tasks/${taskId}`,
  taskNew: (): string => "/tasks/new",
  insights: (): string => "/insights",
  insightNew: ({
    type,
    dashboardId,
    query,
    sceneSource,
  }: {
    type?: InsightType;
    dashboardId?: DashboardType["id"] | null;
    query?: Node;
    sceneSource?: InsightSceneSource;
  } = {}): string => {
    if (isHogQLQuery(query)) {
      return urls.sqlEditor({ query: query.query });
    }
    if ((isDataVisualizationNode(query) || isDataTableNode(query)) && isHogQLQuery(query.source)) {
      return urls.sqlEditor({ query });
    }
    return combineUrl("/insights/new", dashboardId ? { dashboard: dashboardId } : {}, {
      ...(type ? { insight: type } : {}),
      ...(query ? { q: typeof query === "string" ? query : JSON.stringify(query) } : {}),
      ...(sceneSource ? { sceneSource } : {}),
    }).url;
  },
  insightNewHogQL: ({ query, filters }: { query: string; filters?: HogQLFilters }): string =>
    urls.insightNew({
      query: {
        kind: NodeKind.DataTableNode,
        source: { kind: "HogQLQuery", query, filters },
      } as any,
    }),
  insightEdit: (id: InsightShortId, dashboardId?: number): string =>
    `/insights/${id}/edit${dashboardId ? `?dashboard=${dashboardId}` : ""}`,
  insightView: (
    id: InsightShortId,
    dashboardId?: number,
    variablesOverride?: Record<string, HogQLVariable>,
    filtersOverride?: DashboardFilter,
    tileFiltersOverride?: TileFilters,
  ): string => {
    const params = [
      { param: "dashboard", value: dashboardId },
      { param: "variables_override", value: variablesOverride },
      { param: "filters_override", value: filtersOverride },
      { param: "tile_filters_override", value: tileFiltersOverride },
    ]
      .filter((n) => Boolean(n.value))
      .map((n) => `${n.param}=${encodeURIComponent(JSON.stringify(n.value))}`)
      .join("&");
    return `/insights/${id}${params.length ? `?${params}` : ""}`;
  },
  insightSubcriptions: (id: InsightShortId): string => `/insights/${id}/subscriptions`,
  insightSubcription: (id: InsightShortId, subscriptionId: string): string =>
    `/insights/${id}/subscriptions/${subscriptionId}`,
  insightSharing: (id: InsightShortId): string => `/insights/${id}/sharing`,
  savedInsights: (tab?: string): string => `/insights${tab ? `?tab=${tab}` : ""}`,
  insightAlerts: (insightShortId: InsightShortId): string => `/insights/${insightShortId}/alerts`,
  insightAlert: (insightShortId: InsightShortId, alertId: AlertType["id"]): string =>
    `/insights/${insightShortId}/alerts?alert_id=${alertId}`,
  insightQuickStart: (): string => "/insights/quick-start",
  productTours: (): string => "/product_tours",
  productTour: (id: string): string => `/product_tours/${id}`,
  pulse: (): string => "/pulse",
  replay: (
    tab?: ReplayTabs,
    filters?: Partial<RecordingUniversalFilters>,
    sessionRecordingId?: string,
    order?: string,
  ): string =>
    combineUrl(tab ? `/replay/${tab}` : "/replay/home", {
      ...(filters ? { filters } : {}),
      ...(sessionRecordingId ? { sessionRecordingId } : {}),
      ...(order ? { order } : {}),
    }).url,
  replayPlaylist: (id: string): string => `/replay/playlists/${id}`,
  replaySingle: (
    id: string,
    options?: {
      secondsOffsetFromStart?: number;
      unixTimestampMillis?: number;
    },
  ): string => {
    if (options?.unixTimestampMillis) {
      return `/replay/${id}?timestamp=${options.unixTimestampMillis}`;
    }
    if (options?.secondsOffsetFromStart) {
      return `/replay/${id}?t=${options.secondsOffsetFromStart}`;
    }
    return `/replay/${id}`;
  },
  replayFilePlayback: (): string => "/replay/file-playback",
  replayKiosk: (): string => "/replay/kiosk",
  replaySettings: (sectionId?: string): string =>
    `/replay/settings${sectionId ? `?sectionId=${sectionId}` : ""}`,
  replayVision: (id?: string): string => (id ? `/replay-vision/${id}` : "/replay-vision"),
  replayVisionTemplates: (): string => "/replay-vision/new/template",
  replayVisionScannerTemplate: (id: string): string => `/replay-vision/${id}/template`,
  replayVisionScannerConfigure: (id: string): string => `/replay-vision/${id}/configure`,
  replayVisionScannerTriggers: (id: string): string => `/replay-vision/${id}/triggers`,
  replayVisionScannerSelfDriving: (id: string): string => `/replay-vision/${id}/self-driving`,
  replayVisionObservation: (observationId: string): string =>
    `/replay-vision/observations/${observationId}`,
  replayVisionAction: (actionId: string): string => `/replay-vision/actions/${actionId}`,
  replayVisionActionRun: (actionId: string, runId: string): string =>
    `/replay-vision/actions/${actionId}/runs/${runId}`,
  replayVisionActionNew: (scannerId: string, mode?: "group_summary" | "alert"): string =>
    `/replay-vision/${scannerId}/actions/new${mode === "alert" ? "?mode=alert" : ""}`,
  replayVisionActionEdit: (actionId: string): string => `/replay-vision/actions/${actionId}/edit`,
  codeReview: (): string => "/code-review",
  sessionSummaries: (): string => "/session-summaries",
  sessionSummary: (sessionGroupId: string): string => `/session-summaries/${sessionGroupId}`,
  skills: (): string => "/skills",
  skillsCategoryTab: (categoryTab: string): string => `/skills/${categoryTab}`,
  skill: (
    name: string,
    params?: {
      file?: string;
      version?: number;
    },
  ): string => combineUrl(`/skills/${name}`, params).url,
  stamphog: (): string => "/stamphog",
  stamphogCallback: (): string => "/stamphog/install/callback",
  streamlitApps: (): string => "/streamlit-apps",
  streamlitApp: (id: string): string => `/streamlit-apps/${id}`,
  streamlitAppEdit: (id: string): string => `/streamlit-apps/${id}/edit`,
  streamlitAppNew: (): string => "/streamlit-apps/new",
  subscriptions: (): string => "/subscriptions",
  subscription: (id: string | number): string => `/subscriptions/${id}`,
  subscriptionNew: (): string => "/subscriptions/new",
  subscriptionEdit: (id: string | number): string => `/subscriptions/${id}/edit`,
  surveys: (tab?: SurveysTabs): string => `/surveys${tab ? `?tab=${tab}` : ""}`,
  survey: (id: string): string => `/surveys/${id}`,
  surveyFormBuilder: (id: string = "new"): string => `/surveys/form/${id}`,
  surveyWizard: (id: string = "new", template?: string): string =>
    `/surveys/guided/${id}${template ? `?template=${encodeURIComponent(template)}` : ""}`,
  slackTaskContext: (): string => "/slack-task-context",
  toolbarLaunch: (): string => "/toolbar",
  tracing: (): string => "/tracing",
  tracingOperation: (
    serviceName: string,
    spanName: string,
    dateRange?: {
      date_from?: string | null;
      date_to?: string | null;
    },
  ): string =>
    combineUrl("/tracing/operation", {
      service: serviceName,
      name: spanName,
      ...(dateRange ? { dateRange: JSON.stringify(dateRange) } : {}),
    }).url,
  userInterviews: (): string => "/user_research",
  userInterview: (id: string): string => `/user_research/${id}`,
  userInterviewResponse: (topicId: string, responseId: string): string =>
    `/user_research/${topicId}/response/${responseId}`,
  visualReviewRuns: (): string => "/visual_review",
  visualReviewSettings: (): string => "/visual_review/settings",
  visualReviewRun: (runId: string): string => `/visual_review/runs/${runId}`,
  visualReviewRepoRuns: (repoId: string): string => `/visual_review/repos/${repoId}/runs`,
  visualReviewSnapshotOverview: (repoId: string): string =>
    `/visual_review/repos/${repoId}/snapshots`,
  visualReviewSnapshotHistory: (repoId: string, runType: string, identifier: string): string =>
    `/visual_review/repos/${repoId}/${encodeURIComponent(runType)}/snapshots/${encodeURIComponent(identifier)}`,
  webAnalytics: (): string => `/web`,
  webAnalyticsWebVitals: (): string => `/web/web-vitals`,
  webAnalyticsPageReports: (): string => `/web/page-reports`,
  webAnalyticsMarketing: (): string => `/web/marketing`,
  webAnalyticsHealth: (): string => `/web/health`,
  webAnalyticsLive: (): string => `/web/live`,
  webAnalyticsBotAnalytics: (): string => `/web/bot-analytics`,
  workflows: (tab?: WorkflowsSceneTab): string => `/workflows${tab ? `/${tab}` : ""}`,
  workflow: (id: string, tab: string): string => `/workflows/${id}/${tab}`,
  workflowNew: (): string => "/workflows/new/workflow",
  workflowsLibraryMessage: (id: string): string => `/workflows/library/messages/${id}`,
  workflowsLibraryTemplate: (id?: string): string => `/workflows/library/templates/${id}`,
  workflowsLibraryTemplateNew: (): string => "/workflows/library/templates/new",
  workflowsLibraryTemplateFromMessage: (id?: string): string =>
    `/workflows/library/templates/new?messageId=${id}`,
};

/** This const is auto-generated, as is the whole file */
export const fileSystemTypes = {
  action: {
    name: "Action",
    href: (ref: string) => urls.action(ref),
    filterKey: "action",
    iconType: "action" as FileSystemIconType,
    iconColor: ["var(--color-product-actions-light)"] as FileSystemIconColor,
  },
  cohort: {
    name: "Cohort",
    iconType: "cohort" as FileSystemIconType,
    href: (ref: string) => urls.cohort(ref),
    filterKey: "cohort",
    iconColor: ["var(--color-product-cohorts-light)"] as FileSystemIconColor,
  },
  dashboard: {
    name: "Dashboard",
    iconType: "dashboard" as FileSystemIconType,
    href: (ref: string) => urls.dashboard(ref),
    iconColor: ["var(--color-product-dashboards-light)"],
    filterKey: "dashboard",
  },
  early_access_feature: {
    name: "Early access feature",
    iconType: "early_access_feature" as FileSystemIconType,
    href: (ref: string) => urls.earlyAccessFeature(ref),
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ],
    filterKey: "early_access_feature",
  },
  endpoints: {
    name: "Endpoints",
    iconType: "endpoints",
    href: () => urls.endpoints(),
    iconColor: ["var(--color-product-endpoints-light)"],
    filterKey: "endpoints",
    flag: FEATURE_FLAGS.ENDPOINTS,
  },
  experiment: {
    name: "Experiment",
    iconType: "experiment",
    href: (ref: string) => urls.experiment(ref),
    iconColor: ["var(--color-product-experiments-light)"],
    filterKey: "experiment",
  },
  feature_flag: {
    name: "Feature flag",
    iconType: "feature_flag",
    href: (ref: string) => urls.featureFlag(ref),
    iconColor: ["var(--color-product-feature-flags-light)"],
    filterKey: "feature_flag",
  },
  insight: {
    name: "Insight",
    iconType: "product_analytics",
    href: (ref: string) => urls.insightView(ref as InsightShortId),
    iconColor: ["var(--color-product-product-analytics-light)"],
    filterKey: "insight",
  },
  link: {
    name: "Link",
    iconType: "link" as FileSystemIconType,
    href: (ref: string) => urls.link(ref),
    iconColor: ["var(--color-product-links-light)"],
    filterKey: "link",
    flag: FEATURE_FLAGS.LINKS,
  },
  live_debugger: {
    name: "Live Debugger",
    iconType: "live_debugger",
    href: () => urls.liveDebugger(),
    iconColor: ["var(--color-product-live-debugger-light)"],
    filterKey: "live_debugger",
    flag: FEATURE_FLAGS.LIVE_DEBUGGER,
  },
  notebook: {
    name: "Notebook",
    iconType: "notebook",
    href: (ref: string) => urls.notebook(ref),
    filterKey: "notebook",
  },
  product_tour: {
    name: "Product tour",
    iconType: "product_tour",
    href: (ref: string) => urls.productTour(ref),
    iconColor: ["var(--color-product-surveys-light)"],
    filterKey: "product_tour",
  },
  session_recording_playlist: {
    name: "Replay playlist",
    iconType: "session_replay",
    href: (ref: string) => urls.replayPlaylist(ref),
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    filterKey: "session_recording_playlist",
  },
  survey: {
    name: "Survey",
    iconType: "survey",
    href: (ref: string) => urls.survey(ref),
    iconColor: ["var(--color-product-surveys-light)"],
    filterKey: "survey",
  },
  task: {
    name: "Task",
    iconType: "task",
    href: () => urls.taskTracker(),
    iconColor: ["var(--product-tasks-light)", "var(--product-tasks-dark)"],
    filterKey: "task",
    flag: FEATURE_FLAGS.TASKS,
  },
  user_interview: {
    name: "User research",
    iconType: "user_interview",
    href: (ref: string) => urls.userInterview(ref),
    iconColor: ["var(--color-product-user-interviews-light)"],
    filterKey: "user_interview",
    flag: FEATURE_FLAGS.USER_INTERVIEWS,
  },
  workflows: {
    name: "Workflow",
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    href: (ref: string) => urls.workflow(ref, "workflow"),
    filterKey: "workflows",
  },
};

/** This const is auto-generated, as is the whole file */
export const productSetupProbes: ProductSetupProbe[] = [
  {
    productKey: ProductKey.MCP_ANALYTICS,
    hasDataEvents: ["$mcp_tool_call"],
    waitingEvents: ["$mcp_initialize"],
    featureFlag: FEATURE_FLAGS.MCP_ANALYTICS,
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsNew = (): FileSystemImport[] => [
  {
    type: "action",
    path: "Action",
    href: urls.createAction(),
    iconType: "action" as FileSystemIconType,
    iconColor: ["var(--color-product-actions-light)"] as FileSystemIconColor,
  },
  {
    path: `Cohort`,
    type: "cohort",
    href: urls.cohort("new"),
    iconType: "cohort" as FileSystemIconType,
    iconColor: ["var(--color-product-cohorts-light)"] as FileSystemIconColor,
    sceneKeys: ["Cohorts", "Cohort"],
  },
  {
    path: `Dashboard`,
    type: "dashboard",
    href: urls.dashboards() + "#newDashboard=modal",
    iconType: "dashboard" as FileSystemIconType,
    iconColor: ["var(--color-product-dashboards-light)"] as FileSystemIconColor,
    sceneKey: "Dashboard",
    sceneKeys: ["Dashboards", "Dashboard"],
  },
  {
    path: `Data/Destination`,
    type: "hog_function/destination",
    href: urls.dataPipelinesNew("destination"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Source`,
    type: "hog_function/source",
    href: urls.dataPipelinesNew("source"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Transformation`,
    type: "hog_function/transformation",
    href: urls.dataPipelinesNew("transformation"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Web script`,
    type: "hog_function/site_app",
    href: urls.webScriptsNew(),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Early access feature`,
    type: "early_access_feature",
    href: urls.earlyAccessFeature("new"),
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
  },
  {
    path: `Experiment`,
    type: "experiment",
    href: urls.experiment("new"),
    iconType: "experiment",
    iconColor: ["var(--color-product-experiments-light)"] as FileSystemIconColor,
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flag`,
    type: "feature_flag",
    href: urls.featureFlag("new"),
    iconType: "feature_flag",
    iconColor: ["var(--color-product-feature-flags-light)"] as FileSystemIconColor,
  },
  {
    path: `Insight/Funnel`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.FUNNELS }),
    iconType: "insight/funnels",
    visualOrder: INSIGHT_VISUAL_ORDER.funnel,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Lifecycle`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.LIFECYCLE }),
    iconType: "insight/lifecycle",
    visualOrder: INSIGHT_VISUAL_ORDER.lifecycle,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Retention`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.RETENTION }),
    iconType: "insight/retention",
    visualOrder: INSIGHT_VISUAL_ORDER.retention,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/SQL`,
    type: "insight",
    href: urls.sqlEditor({ query: (examples.HogQLForDataVisualization as HogQLQuery).query }),
    displayLabel: "New SQL",
    iconType: "insight/hog",
    visualOrder: INSIGHT_VISUAL_ORDER.sql,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Stickiness`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.STICKINESS }),
    iconType: "insight/stickiness",
    visualOrder: INSIGHT_VISUAL_ORDER.stickiness,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Trends`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.TRENDS }),
    iconType: "insight/trends",
    visualOrder: INSIGHT_VISUAL_ORDER.trends,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/User paths`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.PATHS }),
    iconType: "insight/paths",
    visualOrder: INSIGHT_VISUAL_ORDER.paths,
    sceneKeys: ["Insight"],
  },
  {
    path: `Link`,
    type: "link",
    href: urls.link("new"),
    iconType: "link" as FileSystemIconType,
    iconColor: ["var(--color-product-links-light)"] as FileSystemIconColor,
    flag: FEATURE_FLAGS.LINKS,
  },
  { path: `Notebook`, type: "notebook", href: urls.notebook("new"), iconType: "notebook" },
  {
    path: `Product tour`,
    type: "product_tour",
    href: urls.productTour("new"),
    iconType: "product_tour",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
  },
  {
    path: `Survey`,
    type: "survey",
    href: urls.surveyWizard("new"),
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsProducts = (): FileSystemImport[] => [
  {
    path: "AI gateway",
    intents: [ProductKey.AI_GATEWAY],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "ai_gateway",
    iconType: "ai_gateway" as FileSystemIconType,
    iconColor: [
      "var(--color-product-ai-gateway-light)",
      "var(--color-product-ai-gateway-dark)",
    ] as FileSystemIconColor,
    href: urls.aiGateway(),
    flag: FEATURE_FLAGS.AI_GATEWAY,
    tags: ["alpha"],
    sceneKey: "AIGateway",
    sceneKeys: ["AIGateway"],
  },
  {
    path: "Apps",
    intents: [ProductKey.STREAMLIT_APPS],
    href: urls.streamlitApps(),
    type: "streamlit_app",
    category: ProductItemCategory.UNRELEASED,
    flag: FEATURE_FLAGS.STREAMLIT_APPS,
    iconType: "tools",
    iconColor: ["var(--color-product-data-pipeline-light)"] as FileSystemIconColor,
    sceneKey: "StreamlitApps",
    sceneKeys: ["StreamlitApps", "StreamlitApp", "StreamlitAppEdit"],
  },
  {
    path: "Business knowledge",
    intents: [ProductKey.CONVERSATIONS],
    category: ProductItemCategory.AI_ENGINEERING,
    href: urls.businessKnowledge(),
    tags: ["alpha"],
    iconType: "conversations",
    iconColor: ["var(--color-product-support-light)"] as FileSystemIconColor,
    flag: FEATURE_FLAGS.PRODUCT_BUSINESS_KNOWLEDGE,
    sceneKey: "BusinessKnowledge",
    sceneKeys: ["BusinessKnowledge"],
  },
  {
    path: "Clusters",
    intents: [ProductKey.LLM_CLUSTERS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_clusters",
    iconType: "llm_clusters" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-clusters-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityClusters(),
    sceneKey: "AIObservabilityClusters",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Code review",
    intents: [ProductKey.REVIEW_HOG],
    category: ProductItemCategory.UNRELEASED,
    iconType: "code_review" as FileSystemIconType,
    href: urls.codeReview(),
    flag: FEATURE_FLAGS.REVIEW_HOG,
    tags: ["alpha"],
    sceneKey: "CodeReview",
    sceneKeys: ["CodeReview"],
  },
  {
    path: "Customer analytics",
    intents: [ProductKey.CUSTOMER_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    iconType: "cohort",
    href: urls.customerAnalytics(),
    tags: ["beta"],
    flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS,
    sceneKey: "CustomerAnalytics",
    sceneKeys: ["CustomerAnalytics", "CustomerJourneyTemplates", "CustomerJourneyBuilder"],
  },
  {
    path: "Dashboards",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    type: "dashboard",
    iconType: "dashboard",
    iconColor: ["var(--color-product-dashboards-light)"],
    href: urls.dashboards(),
    sceneKey: "Dashboards",
    sceneKeys: ["Dashboard", "Dashboards"],
  },
  {
    path: "Data catalog",
    intents: [ProductKey.DATA_CATALOG],
    category: ProductItemCategory.ANALYTICS,
    iconType: "data_warehouse",
    href: urls.dataCatalog(),
    flag: FEATURE_FLAGS.PRODUCT_DATA_CATALOG,
    tags: ["alpha"],
    sceneKey: "DataCatalog",
    sceneKeys: ["DataCatalog", "DataCatalogMetric"],
  },
  {
    path: "Data warehouse",
    displayLabel: "Data ops",
    intents: [ProductKey.DATA_WAREHOUSE, ProductKey.DATA_WAREHOUSE_SAVED_QUERY],
    category: ProductItemCategory.UNRELEASED,
    href: urls.dataOps(),
    flag: FEATURE_FLAGS.DATA_WAREHOUSE_SCENE,
    iconType: "data_warehouse",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    sceneKey: "DataOps",
    sceneKeys: [
      "DataOps",
      "Models",
      "NodeDetail",
      "SQLEditor",
      "Sources",
      "DataWarehouseSource",
      "DataWarehouseSourceNew",
      "DataWarehouseSourceConnect",
      "DataWarehouseSourceSchema",
    ],
  },
  {
    path: "Datasets",
    intents: [ProductKey.LLM_DATASETS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_datasets",
    iconType: "llm_datasets" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-datasets-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityDatasets(),
    flag: FEATURE_FLAGS.LLM_ANALYTICS_DATASETS,
    tags: ["beta"],
    sceneKey: "AIObservabilityDatasets",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Early access features",
    intents: [ProductKey.EARLY_ACCESS_FEATURES],
    category: ProductItemCategory.FEATURES,
    type: "early_access_feature",
    href: urls.earlyAccessFeatures(),
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
    sceneKey: "EarlyAccessFeatures",
    sceneKeys: ["EarlyAccessFeatures", "EarlyAccessFeature"],
  },
  {
    path: "Endpoints",
    intents: [ProductKey.ENDPOINTS],
    category: ProductItemCategory.TOOLS,
    href: urls.endpoints(),
    type: "endpoints",
    flag: FEATURE_FLAGS.ENDPOINTS,
    iconType: "endpoints",
    iconColor: ["var(--color-product-endpoints-light)"] as FileSystemIconColor,
    sceneKey: "EndpointsScene",
    sceneKeys: ["EndpointsScene", "EndpointScene"],
  },
  {
    path: "Engineering analytics",
    intents: [ProductKey.ENGINEERING_ANALYTICS],
    category: ProductItemCategory.UNRELEASED,
    type: "engineering_analytics",
    iconType: "health" as FileSystemIconType,
    iconColor: ["var(--color-product-data-warehouse-light)"] as FileSystemIconColor,
    href: urls.engineeringAnalytics(),
    flag: FEATURE_FLAGS.ENGINEERING_ANALYTICS,
    tags: ["alpha"],
    sceneKey: "EngineeringAnalytics",
    sceneKeys: [
      "EngineeringAnalytics",
      "EngineeringAnalyticsPullRequest",
      "EngineeringAnalyticsWorkflowRun",
      "EngineeringAnalyticsWorkflowRuns",
      "EngineeringAnalyticsAuthor",
      "EngineeringAnalyticsTeam",
    ],
  },
  {
    path: "Error tracking",
    intents: [ProductKey.ERROR_TRACKING],
    category: ProductItemCategory.APP_MONITORING,
    type: "error_tracking",
    iconType: "error_tracking" as FileSystemIconType,
    iconColor: [
      "var(--color-product-error-tracking-light)",
      "var(--color-product-error-tracking-dark)",
    ] as FileSystemIconColor,
    href: urls.errorTracking(),
    sceneKey: "ErrorTracking",
    sceneKeys: [
      "ErrorTracking",
      "ErrorTrackingIssue",
      "ErrorTrackingIssueFingerprints",
      "ErrorTrackingFingerprint",
    ],
  },
  {
    path: "Evaluations",
    intents: [ProductKey.LLM_EVALUATIONS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_evaluations",
    iconType: "llm_evaluations" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-evaluations-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityEvaluations(),
    sceneKey: "AIObservabilityEvaluations",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: `Experiments`,
    intents: [ProductKey.EXPERIMENTS],
    category: ProductItemCategory.FEATURES,
    type: "experiment",
    href: urls.experiments(),
    iconType: "experiment",
    iconColor: ["var(--color-product-experiments-light)"] as FileSystemIconColor,
    sceneKey: "Experiments",
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flags`,
    intents: [ProductKey.FEATURE_FLAGS, ProductKey.EXPERIMENTS, ProductKey.EARLY_ACCESS_FEATURES],
    category: ProductItemCategory.FEATURES,
    type: "feature_flag",
    href: urls.featureFlags(),
    sceneKey: "FeatureFlags",
    sceneKeys: ["FeatureFlags", "FeatureFlag"],
  },
  {
    path: "Heatmaps",
    intents: [ProductKey.HEATMAPS],
    category: ProductItemCategory.BEHAVIOR,
    iconType: "heatmap",
    iconColor: ["var(--color-product-heatmaps-light)", "var(--color-product-heatmaps-dark)"],
    href: urls.heatmaps(),
    tags: ["beta"],
    sceneKey: "Heatmaps",
    sceneKeys: ["Heatmaps"],
  },
  {
    path: "Identity matching",
    intents: [ProductKey.MARKETING_ANALYTICS],
    category: ProductItemCategory.UNRELEASED,
    href: urls.identityMatching(),
    flag: FEATURE_FLAGS.IDENTITY_MATCHING,
    tags: ["alpha"],
    iconType: "persons",
    sceneKey: "IdentityMatching",
    sceneKeys: ["IdentityMatching"],
  },
  {
    path: "LLM analytics",
    displayLabel: "AI observability",
    intents: [
      ProductKey.AI_OBSERVABILITY,
      ProductKey.LLM_EVALUATIONS,
      ProductKey.LLM_DATASETS,
      ProductKey.LLM_PROMPTS,
      ProductKey.LLM_CLUSTERS,
    ],
    category: ProductItemCategory.AI_ENGINEERING,
    visualOrder: 1,
    type: "llm_analytics",
    iconType: "llm_analytics" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-analytics-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityDashboard(),
    sceneKey: "AIObservability",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Links",
    intents: [ProductKey.LINKS],
    category: ProductItemCategory.UNRELEASED,
    type: "link",
    href: urls.links(),
    flag: FEATURE_FLAGS.LINKS,
    tags: ["alpha"],
    sceneKey: "Links",
    sceneKeys: ["Links", "Link"],
  },
  {
    path: "Live Debugger",
    intents: [ProductKey.LIVE_DEBUGGER],
    category: ProductItemCategory.UNRELEASED,
    type: "live_debugger",
    href: urls.liveDebugger(),
    flag: FEATURE_FLAGS.LIVE_DEBUGGER,
    iconType: "live_debugger",
    tags: ["alpha"],
    iconColor: ["var(--color-product-live-debugger-light)"] as FileSystemIconColor,
    sceneKeys: ["LiveDebugger"],
  },
  {
    path: "Logs",
    intents: [ProductKey.LOGS],
    category: ProductItemCategory.APP_MONITORING,
    iconType: "logs" as FileSystemIconType,
    iconColor: ["var(--color-product-logs-light)"] as FileSystemIconColor,
    href: urls.logs(),
    sceneKey: "Logs",
    sceneKeys: [
      "Logs",
      "LogsAlertDetail",
      "LogsAlertNotificationDetail",
      "LogsSamplingNew",
      "LogsSamplingDetail",
    ],
  },
  {
    path: "MCP analytics",
    intents: [ProductKey.MCP_ANALYTICS],
    category: ProductItemCategory.AI_ENGINEERING,
    visualOrder: 2,
    type: "mcp_analytics",
    iconType: "mcp_analytics" as FileSystemIconType,
    iconColor: [
      "var(--color-product-mcp-analytics-light)",
      "var(--color-product-mcp-analytics-dark)",
    ] as FileSystemIconColor,
    href: urls.mcpAnalyticsDashboard(),
    flag: FEATURE_FLAGS.MCP_ANALYTICS,
    tags: ["beta"],
    sceneKey: "MCPAnalytics",
    sceneKeys: ["MCPAnalytics", "MCPAnalyticsToolDetail"],
  },
  {
    path: "Marketing analytics",
    intents: [ProductKey.MARKETING_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    href: urls.marketingAnalyticsApp(),
    iconType: "marketing_analytics" as FileSystemIconType,
    iconColor: ["var(--color-product-marketing-analytics-light)"] as FileSystemIconColor,
    tags: ["beta"],
    flag: FEATURE_FLAGS.WEB_ANALYTICS_MARKETING,
    sceneKey: "MarketingAnalytics",
    sceneKeys: ["MarketingAnalytics"],
  },
  {
    path: "Metrics",
    intents: [ProductKey.METRICS],
    category: ProductItemCategory.APP_MONITORING,
    iconType: "metrics",
    iconColor: [
      "var(--color-product-metrics-light)",
      "var(--color-product-metrics-dark)",
    ] as FileSystemIconColor,
    href: urls.metrics(),
    flag: FEATURE_FLAGS.METRICS,
    tags: ["alpha"],
    sceneKey: "Metrics",
    sceneKeys: ["Metrics"],
  },
  {
    path: "Notebooks",
    intents: [ProductKey.NOTEBOOKS],
    category: ProductItemCategory.TOOLS,
    type: "notebook",
    iconType: "notebook",
    href: urls.notebooks(),
    sceneKey: "Notebooks",
    sceneKeys: ["Notebook", "Notebooks"],
  },
  {
    path: "Playground",
    intents: [ProductKey.AI_OBSERVABILITY],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_playground",
    iconType: "llm_playground" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-analytics-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityPlayground(),
    sceneKey: "AIObservabilityPlayground",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Product analytics",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    type: "insight",
    href: urls.insights(),
    iconType: "product_analytics",
    iconColor: ["var(--color-product-product-analytics-light)"],
    sceneKey: "SavedInsights",
    sceneKeys: ["SavedInsights", "Insight"],
  },
  {
    path: "Product tours",
    intents: [ProductKey.PRODUCT_TOURS],
    category: ProductItemCategory.BEHAVIOR,
    type: "product_tour",
    href: urls.productTours(),
    iconType: "product_tour",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
    sceneKey: "ProductTours",
    sceneKeys: ["ProductTour", "ProductTours"],
    flag: FEATURE_FLAGS.PRODUCT_TOURS,
  },
  {
    path: "Prompts",
    intents: [ProductKey.LLM_PROMPTS],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_prompts",
    iconType: "llm_prompts" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-prompts-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityPrompts(),
    tags: ["beta"],
    sceneKey: "AIObservabilityPrompts",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Pulse",
    intents: [ProductKey.PULSE],
    category: ProductItemCategory.UNRELEASED,
    iconType: "activity",
    iconColor: [
      "var(--color-product-activity-light)",
      "var(--color-product-activity-dark)",
    ] as FileSystemIconColor,
    href: urls.pulse(),
    flag: FEATURE_FLAGS.PULSE,
    tags: ["alpha"],
    sceneKey: "Pulse",
    sceneKeys: ["Pulse"],
  },
  {
    path: "Replay vision",
    category: ProductItemCategory.BEHAVIOR,
    intents: [ProductKey.REPLAY_VISION],
    type: "replay_vision",
    iconType: "replay_vision" as FileSystemIconType,
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ] as FileSystemIconColor,
    href: urls.replayVision(),
    tags: ["beta"],
    flag: FEATURE_FLAGS.REPLAY_VISION,
    sceneKey: "ReplayVision",
    sceneKeys: ["ReplayVision", "ReplayVisionScanner"],
  },
  {
    path: "SQL editor",
    intents: [ProductKey.DATA_WAREHOUSE_SAVED_QUERY, ProductKey.DATA_WAREHOUSE],
    category: ProductItemCategory.ANALYTICS,
    type: "sql",
    iconType: "sql_editor",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    href: urls.sqlEditor(),
    sceneKey: "SQLEditor",
    sceneKeys: ["SQLEditor"],
  },
  {
    path: "Session replay",
    intents: [ProductKey.SESSION_REPLAY, ProductKey.MOBILE_REPLAY],
    category: ProductItemCategory.BEHAVIOR,
    href: urls.replay(ReplayTabs.Home),
    type: "session_recording_playlist",
    iconType: "session_replay",
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    sceneKey: "Replay",
    sceneKeys: [
      "Replay",
      "ReplaySingle",
      "ReplaySettings",
      "ReplayPlaylist",
      "ReplayFilePlayback",
      "ReplayKiosk",
    ],
  },
  {
    path: "Skills",
    intents: [ProductKey.SKILLS],
    category: ProductItemCategory.TOOLS,
    type: "llm_skills",
    iconType: "llm_prompts" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-prompts-light)"] as FileSystemIconColor,
    href: urls.skills(),
    sceneKey: "Skills",
    sceneKeys: ["Skills", "Skill"],
  },
  {
    path: "Support",
    intents: [ProductKey.CONVERSATIONS],
    category: ProductItemCategory.BEHAVIOR,
    href: urls.supportTickets(),
    type: "conversations",
    iconType: "conversations",
    iconColor: ["var(--color-product-support-light)"] as FileSystemIconColor,
    sceneKey: "SupportTickets",
    sceneKeys: ["SupportTickets", "SupportTicketDetail", "SupportSettings"],
  },
  {
    path: "Surveys",
    intents: [ProductKey.SURVEYS],
    category: ProductItemCategory.BEHAVIOR,
    type: "survey",
    href: urls.surveys(),
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
    sceneKey: "Surveys",
    sceneKeys: ["Survey", "Surveys"],
  },
  {
    path: "Taggers",
    intents: [ProductKey.AI_OBSERVABILITY],
    category: ProductItemCategory.AI_ENGINEERING,
    type: "llm_tags",
    iconType: "llm_tags" as FileSystemIconType,
    iconColor: ["var(--color-product-llm-analytics-light)"] as FileSystemIconColor,
    href: urls.aiObservabilityTags(),
    flag: FEATURE_FLAGS.LLM_ANALYTICS_TAGS,
    tags: ["alpha"],
    sceneKey: "AIObservabilityTags",
    sceneKeys: [
      "AIObservability",
      "AIObservabilityTrace",
      "AIObservabilitySession",
      "AIObservabilityUsers",
      "AIObservabilityPlayground",
      "AIObservabilityDatasets",
      "AIObservabilityDataset",
      "AIObservabilityEvaluations",
      "AIObservabilityEvaluation",
      "AIObservabilityEvaluationTemplates",
      "AIObservabilityTags",
      "AIObservabilityTag",
      "AIObservabilityPrompts",
      "AIObservabilityPrompt",
      "AIObservabilityClusters",
      "AIObservabilityCluster",
    ],
  },
  {
    path: "Tasks",
    intents: [ProductKey.TASKS],
    category: ProductItemCategory.TOOLS,
    type: "task",
    iconType: "task",
    iconColor: ["var(--product-tasks-light)", "var(--product-tasks-dark)"] as FileSystemIconColor,
    href: urls.taskTracker(),
    sceneKey: "TaskTracker",
    flag: FEATURE_FLAGS.TASKS,
    sceneKeys: ["TaskTracker"],
  },
  {
    path: "Toolbar",
    intents: [ProductKey.TOOLBAR],
    href: urls.toolbarLaunch(),
    type: "toolbar",
    category: ProductItemCategory.TOOLS,
    iconType: "toolbar",
    sceneKey: "Toolbar",
    sceneKeys: ["Toolbar"],
  },
  {
    path: "Tracing",
    intents: [ProductKey.TRACING],
    category: ProductItemCategory.APP_MONITORING,
    iconType: "tracing",
    iconColor: ["var(--color-product-tracing-light)"] as FileSystemIconColor,
    href: urls.tracing(),
    flag: FEATURE_FLAGS.TRACING,
    tags: ["beta"],
    sceneKey: "Tracing",
    sceneKeys: ["Tracing", "TracingOperation"],
  },
  {
    path: "User research",
    intents: [ProductKey.USER_INTERVIEWS],
    category: ProductItemCategory.UNRELEASED,
    href: urls.userInterviews(),
    type: "user_interview",
    flag: FEATURE_FLAGS.USER_INTERVIEWS,
    tags: ["alpha"],
    iconType: "user_interview",
    iconColor: ["var(--color-product-user-interviews-light)"] as FileSystemIconColor,
    sceneKey: "UserInterviews",
    sceneKeys: ["UserInterviews", "UserInterview", "UserInterviewResponse"],
  },
  {
    path: "Visual review",
    intents: [ProductKey.VISUAL_REVIEW],
    category: ProductItemCategory.UNRELEASED,
    href: urls.visualReviewRuns(),
    iconType: "visual_review" as FileSystemIconType,
    flag: FEATURE_FLAGS.VISUAL_REVIEW,
    tags: ["alpha"],
    sceneKey: "VisualReviewIndex",
    sceneKeys: [
      "VisualReviewIndex",
      "VisualReviewRuns",
      "VisualReviewRun",
      "VisualReviewSettings",
      "VisualReviewSnapshotHistory",
      "VisualReviewSnapshotOverview",
    ],
  },
  {
    path: "Web analytics",
    intents: [ProductKey.WEB_ANALYTICS],
    category: ProductItemCategory.ANALYTICS,
    iconType: "web_analytics",
    iconColor: ["var(--color-product-web-analytics-light)"] as FileSystemIconColor,
    href: urls.webAnalytics(),
    sceneKey: "WebAnalytics",
    sceneKeys: ["WebAnalytics"],
  },
  {
    path: "Web scripts",
    intents: [ProductKey.SITE_APPS],
    category: ProductItemCategory.TOOLS,
    type: "hog_function",
    iconType: "data_pipeline",
    iconColor: ["var(--color-product-data-pipeline-light)"],
    href: urls.webScripts(),
    sceneKey: "WebScripts",
    sceneKeys: ["WebScripts"],
  },
  {
    path: "Workflows",
    intents: [ProductKey.WORKFLOWS],
    href: urls.workflows(),
    type: "workflows",
    category: ProductItemCategory.TOOLS,
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    sceneKey: "Workflows",
    sceneKeys: ["Workflows", "Workflow", "WorkflowsLibraryTemplate"],
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsGames = (): FileSystemImport[] => [
  { path: "368 Hedgehogs", href: urls.game368hedgehogs() },
  { path: "Flappy Hog", href: "/games/flappyhog" },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsMetadata = (): FileSystemImport[] => [
  {
    path: "Actions",
    category: "Schema",
    href: urls.actions(),
    iconType: "action" as FileSystemIconType,
    sceneKey: "Actions",
    sceneKeys: ["Actions", "Action", "NewAction"],
  },
  {
    path: "Annotations",
    category: "Metadata",
    iconType: "annotation",
    href: urls.annotations(),
    sceneKey: "Annotations",
    sceneKeys: ["Annotations"],
  },
  {
    path: "Comments",
    category: "Metadata",
    iconType: "comment",
    href: urls.comments(),
    sceneKey: "Comments",
    sceneKeys: ["Comments"],
  },
  {
    path: "Core events",
    category: "Schema",
    iconType: "event_definition" as FileSystemIconType,
    href: urls.coreEvents(),
    flag: FEATURE_FLAGS.NEW_TEAM_CORE_EVENTS,
    sceneKeys: [],
  },
  {
    path: `Destinations`,
    category: "Pipeline",
    type: "hog_function/destination",
    iconType: "data_pipeline_metadata",
    href: urls.destinations(),
    sceneKey: "Destinations",
    sceneKeys: ["Destinations"],
  },
  {
    path: "Endpoints",
    category: "Tools",
    iconType: "endpoints" as FileSystemIconType,
    iconColor: ["var(--color-product-endpoints-light)"] as FileSystemIconColor,
    href: urls.endpoints(),
    sceneKey: "EndpointsScene",
    flag: FEATURE_FLAGS.ENDPOINTS,
    sceneKeys: ["EndpointsScene", "EndpointScene"],
  },
  {
    path: "Event definitions",
    category: "Schema",
    iconType: "event_definition",
    href: urls.eventDefinitions(),
    sceneKey: "EventDefinitions",
    sceneKeys: ["EventDefinition", "EventDefinitions"],
  },
  {
    path: "Event ingestion filtering",
    category: "Pipeline",
    type: "event_filter",
    iconType: "data_pipeline_metadata",
    href: urls.eventFiltering(),
    sceneKey: "EventFiltering",
    sceneKeys: ["EventFiltering"],
  },
  {
    path: "Event ingestion warnings",
    category: "Pipeline",
    iconType: "ingestion_warning",
    href: urls.ingestionWarnings(),
    sceneKey: "IngestionWarnings",
    sceneKeys: ["IngestionWarnings"],
  },
  {
    path: "Managed migrations",
    category: "Pipeline",
    iconType: "data_pipeline_metadata",
    href: urls.managedMigration(),
    sceneKey: "ManagedMigration",
    sceneKeys: ["ManagedMigration", "ManagedMigrationNew"],
  },
  {
    path: "Managed viewsets",
    category: "Unreleased",
    iconType: "managed_viewsets",
    href: urls.dataWarehouseManagedViewsets(),
    flag: FEATURE_FLAGS.MANAGED_VIEWSETS,
    sceneKeys: [
      "DataOps",
      "Models",
      "NodeDetail",
      "SQLEditor",
      "Sources",
      "DataWarehouseSource",
      "DataWarehouseSourceNew",
      "DataWarehouseSourceConnect",
      "DataWarehouseSourceSchema",
    ],
  },
  {
    path: "Models",
    category: "Tools",
    type: "sql",
    iconType: "sql_editor",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    href: urls.models(),
    sceneKey: "Models",
    sceneKeys: ["Models"],
  },
  {
    path: "Property definitions",
    category: "Schema",
    iconType: "property_definition",
    href: urls.propertyDefinitions(),
    sceneKey: "PropertyDefinitions",
    sceneKeys: ["PropertyDefinition", "PropertyDefinitions"],
  },
  {
    path: "Property groups",
    category: "Schema",
    iconType: "event_definition",
    href: urls.schemaManagement(),
    flag: FEATURE_FLAGS.SCHEMA_MANAGEMENT,
    sceneKeys: [],
  },
  {
    path: "Revenue definitions",
    category: "Schema",
    iconType: "revenue_analytics_metadata" as FileSystemIconType,
    href: urls.revenueSettings(),
    sceneKey: "DataManagement",
    sceneKeys: [],
  },
  {
    path: "SQL variables",
    category: "Schema",
    href: urls.variables(),
    sceneKeys: ["SqlVariableEdit"],
  },
  {
    path: `Sources`,
    category: "Pipeline",
    type: "hog_function/source",
    iconType: "data_pipeline_metadata",
    href: urls.sources(),
    sceneKey: "Sources",
    sceneKeys: ["Sources"],
  },
  {
    path: `Transformations`,
    category: "Pipeline",
    type: "hog_function/transformation",
    iconType: "data_pipeline_metadata",
    href: urls.transformations(),
    sceneKey: "Transformations",
    sceneKeys: ["Transformations"],
  },
];
